import Image from "next/image";
import { EJHEALTH_COLORS, EJHEALTH_TYPE } from "@/lib/theme/ej-health";
import { AdBand } from "@/components/shared/main/ad-band";
import { AdSlot as GamAdSlot } from "@/components/ads/ad-slot";


/** Shared IAB ad placeholder — caption + fixed-aspect creative box. */
function AdUnit({
  slot,
  size,
  src,
  ratio,
  sticky = false,
}: {
  slot: string;
  size: string;
  src: string;
  ratio: number;
  sticky?: boolean;
}) {
  return (
    <AdBand label="廣告　Ad" className={sticky ? "lg:sticky hkej-sticky-offset" : ""}>
      <GamAdSlot unit={slot === "HALF_PAGE" ? "HalfPage" : "LargeRectangle"} className="w-full">
      <div
        aria-label="廣告"
        data-ad-slot={slot}
        data-ad-size={size}
        className="relative mx-auto block w-full md:max-w-[300px] overflow-hidden"
        style={{
          aspectRatio: ratio,
          backgroundColor: EJHEALTH_COLORS.surfaceAlt,
        }}
      >
        <Image
          src={src}
          alt="廣告"
          fill
          className="object-cover"
          sizes="(max-width: 768px) 100vw, 300px"
          unoptimized
        />
      </div>
      </GamAdSlot>
    </AdBand>
  );
}

/**
 * IAB Large Rectangle 300×250.
 *
 * `src` exists because a rail can carry two of these, and two identical
 * creatives stacked in one column read as a rendering fault rather than as two
 * bookings — QA: "do not have duplicated ad units, change to different
 * images". Pass a different creative for the second slot.
 */
export function LrecAd({
  sticky = false,
  src = "/images/home/sidebar-ad-300x250.png",
}: { sticky?: boolean; src?: string } = {}) {
  return (
    <AdUnit slot="LREC" size="300x250" src={src} ratio={6 / 5} sticky={sticky} />
  );
}

/**
 * IAB Half Page Unit 300×600 — DESKTOP ONLY.
 *
 * Gated at `lg` (1280px per the globals.css breakpoint override, which keeps
 * iPads in the `md` bucket). Below that, SEGMENT_GRID has already collapsed the
 * sidebar to full width, so a 600px-tall creative dominated the tablet view —
 * QA: "廣告在平板上的擺放位置看起來太長了，往下滑的時候幾乎佔了超過一整個頁面".
 * The sibling LrecAd (300×250) covers the slot below lg, so nothing is empty.
 */
export function HalfPageAd() {
  return (
    <div className="hidden w-full lg:block">
      <AdUnit slot="HALF_PAGE" size="300x600" src="/images/article-detail/ad-tall.png" ratio={1 / 2} />
    </div>
  );
}
